import Intellibrand from "../services/Intellibrand";
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {

    components: { 'slick-carousel' : VueSlickCarousel },

    props: [ 'eansToLoad' ],

    data: () => ({
        eans: [],
        offers: {},
        productsInModal: [],
        defaultProduct: '',
        isLoading: true,
        showSellerProductsModal: false,
        slickSettings: {
            arrows: true,
            adaptiveHeight: false,
            draggable: true,
            dots: false,
            infinite: true,
            speed: 300,
            variableWidth: false,
            responsive: [
                {
                    breakpoint: 9000,
                    settings: {
                        slidesToShow: Math.round($(".main-container").width() / 350),
                    }
                },
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        }
    }),

    mounted() {
        this.loadOffers();
    },

    methods: {

        showProductSelection(offerName){
            if(this.eans.length < 2) return;
            this.productsInModal = this.offers[offerName].products;
            this.showSellerProductsModal = true;
        },

        loadOffers() {

            this.eans = this.eansToLoad.split(',');

            this.isLoading = true;
            Intellibrand.fetchOffers(this.eans)
                .then((products) => {
                    this.isLoading = false

                    if(this.eans.length === 1) {
                        this.defaultProduct = products[0].name;
                    }

                    products.forEach((sku) => {

                        if (!sku.offers) {
                            console.warn("SKU has no offers: ", sku.ean);
                            return;
                        }

                        Object.values(sku.offers).forEach((offer) => {
                            if(!offer.available) return

                            if(this.offers[offer.retailer] === undefined) {
                                this.offers[offer.retailer] = {
                                    image: offer.retailerLogo,
                                    products: {},
                                }
                            }

                            this.offers[offer.retailer].products[sku.name] = offer.url

                        })
                    })

                    this.$forceUpdate()

                }).catch((err) => {
                    this.isLoading = false
                })

        }

    },

}
